module.exports = __webpack_public_path__ + "media/images/about/1-01946cb959bb961cddead6e47cf3341e.jpg";